import PropTypes from 'prop-types';
import './SkeletonLoader.css';

/**
 * Skeleton loader component with shimmer effect
 * @param {string} variant - Type of skeleton: 'card', 'text', 'image', 'button', 'avatar'
 * @param {number} count - Number of skeleton items to render
 * @param {string} className - Additional CSS classes
 * @param {string} width - Custom width
 * @param {string} height - Custom height
 */
function SkeletonLoader({ variant = 'text', count = 1, className = '', width, height }) {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  const getVariantClass = () => {
    switch (variant) {
      case 'card':
        return 'skeleton--card';
      case 'text':
        return 'skeleton--text';
      case 'image':
        return 'skeleton--image';
      case 'button':
        return 'skeleton--button';
      case 'avatar':
        return 'skeleton--avatar';
      default:
        return 'skeleton--text';
    }
  };

  const style = {};
  if (width) style.width = width;
  if (height) style.height = height;

  if (variant === 'card') {
    return (
      <div className={`skeleton-container ${className}`}>
        {skeletons.map(i => (
          <div key={i} className="skeleton skeleton--card" style={style}>
            <div className="skeleton__media" />
            <div className="skeleton__content">
              <div className="skeleton skeleton--text skeleton--title" />
              <div className="skeleton skeleton--text" />
              <div className="skeleton skeleton--text" />
              <div className="skeleton skeleton--button" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`skeleton-container ${className}`}>
      {skeletons.map(i => (
        <div key={i} className={`skeleton ${getVariantClass()}`} style={style} />
      ))}
    </div>
  );
}

SkeletonLoader.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
  height: PropTypes.string,
  variant: PropTypes.oneOf(['card', 'text', 'image', 'button', 'avatar']),
  width: PropTypes.string
};

SkeletonLoader.defaultProps = {
  className: '',
  count: 1,
  height: undefined,
  variant: 'text',
  width: undefined
};

export default SkeletonLoader;
